// import { shortenUUID } from "./uuids";

export const paths = {
  song: (id: string, { secret, playlistId }: { secret?: string, playlistId?: string } = {}) => {
    const base = playlistId ? `/playlist/${playlistId}/song/${id}` : `/song/${id}`

    if (secret) {
      return `${base}?s=${secret}`
    }

    return base
  },
  playlist: (id: string, { secret }: { secret?: string } = {}) =>
    secret ? `/playlist/${id}?s=${secret}` : `/playlist/${id}`,
  embedPlaylist: (id: string, { secret }: { secret?: string } = {}) =>
    secret ? `/embed/playlist/${id}?s=${secret}` : `/embed/playlist/${id}`,
  home: "/home",
  all: `/all`,
  playlists: `/playlists`,
  upload: (playlistId?: string) => playlistId ? `/upload?playlistId=${playlistId}` : `/upload`,
  newSong: (playlistId?: string) => playlistId ? `/new?playlistId=${playlistId}` : `/new`,
  signIn: (redirect?: string) => `/signin${redirect ? `?redirect=${redirect}` : ""}`,
  recover: `/auth/recover`,
  resetPassword: `/auth/reset-password`,
  authCallback: `/auth/callback`,
  register: `/register`,
  root: "/",
  landing: "/landing",
  demo: "/demo",
  support: "/support",
  account: "/account",
  earlyAccess: "/early-access",
  donate: "/donate",
  help: "/help",
  admin: "/admin",
  dev: "/dev",
  changelog: "/changelog",
  docs: {
    index: "/docs",
    gettingStarted: "/docs/getting-started",
    uploadingTracks: "/docs/uploading-tracks",
    player: "/docs/player",
    keyboardShortcuts: "/docs/keyboard-shortcuts",
    playlists: "/docs/playlists",
    sharing: "/docs/sharing",
    embedding: "/docs/embedding",
    recording: "/docs/recording",
    account: "/docs/account",
  },
  devAudioHarness: "/dev/audio-harness",
  error: (code: number) => `/${code}`,
};

export const getAbsolutePath = (path: string) => {
  const origin = window.location.origin;

  return `${origin}${path}`
}
